import { Link } from '@remix-run/react'
import { SpotlightBodyHydrated } from './SpotlightBodyHydrated.tsx'

export type SpotlightDetailProps = {
  title: string
  summary: string | null
  bannerImageUrl: string | null
  bodyHtml: string
  /** ISO 8601; exibida no hero ou no cabeçalho quando não houver banner. */
  publishedAt?: string | null
}

function formatSpotlightPublishedDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(d)
}

function BackToNovidadesLink({ className }: { className?: string }) {
  return (
    <Link
      to="/novidades"
      className={`fw-semibold text-primary spotlight-article-back ${className ?? ''}`}
    >
      ← Voltar para novidades
    </Link>
  )
}

function SpotlightPublishedAt({
  publishedAt,
  className,
}: {
  publishedAt: string
  className?: string
}) {
  const label = formatSpotlightPublishedDate(publishedAt)
  if (!label) return null
  return (
    <p className={`spotlight-article-date mb-0 ${className ?? ''}`}>
      <i className="mdi mdi-clock-outline me-1 align-middle" aria-hidden />
      <time dateTime={publishedAt}>{label}</time>
    </p>
  )
}

export function SpotlightDetail({
  title,
  summary,
  bannerImageUrl,
  bodyHtml,
  publishedAt = null,
}: SpotlightDetailProps) {
  return (
    <article className="spotlight-article">
      <header className="mb-4">
        {bannerImageUrl ? (
          <div className="rounded overflow-hidden mb-4 position-relative spotlight-article-hero spotlight-article-hero--banner">
            <div className="spotlight-article-hero-media">
              <img
                src={bannerImageUrl}
                alt=""
                className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
              />
            </div>
            <div
              className="spotlight-article-hero-gradient position-absolute top-0 start-0 w-100 h-100"
              aria-hidden
            />
            <div className="spotlight-article-hero-content position-relative z-1 d-flex flex-column justify-content-end text-start w-100 min-w-0">
              <h1 className="spotlight-article-title text-white fw-bold">{title}</h1>
              {summary ? (
                <p className="spotlight-article-dek text-white mb-0">
                  {summary}
                </p>
              ) : null}
              {publishedAt ? (
                <SpotlightPublishedAt
                  publishedAt={publishedAt}
                  className="mt-3 spotlight-article-date--on-hero"
                />
              ) : null}
            </div>
          </div>
        ) : (
          <>
            <h1 className="spotlight-article-title text-primary">{title}</h1>
            {summary ? (
              <p className="spotlight-article-dek mb-0">{summary}</p>
            ) : null}
            {publishedAt ? (
              <SpotlightPublishedAt
                publishedAt={publishedAt}
                className="mt-3 text-body-secondary"
              />
            ) : null}
          </>
        )}
      </header>
      <SpotlightBodyHydrated bodyHtml={bodyHtml} />
      <p className="spotlight-article-back-wrap mt-5 mb-0">
        <BackToNovidadesLink />
      </p>
    </article>
  )
}
